import {
	Box,
	TextField,
	InputAdornment,
	Grid,
	Button,
	Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import React from "react";
import { sizes } from "../../setupUtils";
import CreateTransferList from "./CreateTransferList";
import CreateBasicModal from "./CreateBasicModal";
import { useDispatch, useSelector } from "react-redux";
import { getProductGroups, setPGState } from "../productGroupSetupSlice";
import CollapseSection from "../../../../components/ui/CollapseSection";

export default function CreateSelectSKU() {
	const pgState = useSelector((store) => store.productGroupSetup);
	const { country, skus, selectedSKUs, countryID, searchedPGName, is_sku_refresh } = pgState;
	const dispatch = useDispatch();

	function showMessage(message, severity) {
		dispatch(setPGState("createMessageOpen", true));
		dispatch(setPGState("createMessage", message));
		dispatch(setPGState("createMessageSeverity", severity));
	}

	function updateSearchedPGName(event) {
		const name = event.target.value;
		dispatch(setPGState("searchedPGName", name));
	}

	function searchSKUs() {
		dispatch(setPGState("is_sku_refresh", true));
		if (country.length <= 0) {
			showMessage("Please select a country", "info");
			return;
		}
		const productGroupName = searchedPGName;
		dispatch(getProductGroups({ countryID, productGroupName }));
	}
	return (
		<Box>
				{/* <Typography className="compHeading"
					sx={{ fontWeight: "bold", color: "blue.main" }}
					gutterBottom
				>
					Select SKU to add
				</Typography> */}
		<CollapseSection title="Select SKU to add">
		<Box sx={{ mt: 2, border: "1px solid #e0e0e0", borderRadius: 1, p: 2,  }}>
			
			<Box sx={{ mt: 1 }}>
				<Grid container columns={10} spacing={3} rowGap={2}>
					<Grid item sm={7.5} md={8.5} lg={8.9}>
						<TextField
							label="SKU"
							InputProps={{
								startAdornment: (
									<InputAdornment position="end">
										<EditIcon />
									</InputAdornment>
								),
							}}
							variant="standard"
							value={searchedPGName}
							onChange={updateSearchedPGName}
						/>
					</Grid>

					<Grid item sm={.8}>
						<Button
							startIcon={<KeyboardArrowRightIcon />}
							sx={{
								bgcolor: "blue.main",
								color: "white.main",
								textTransform: "none",
								mt: 1,
								"&:hover": {
									bgcolor: "lightBlue.main",
								},
							}}
							onClick={searchSKUs}
						>
							<Typography
								sx={{ fontWeight: "bold", color: "white.main" }}
							>
								Go
							</Typography>
						</Button>
					</Grid>
				</Grid>
			</Box>

			<CreateTransferList
				leftList={skus}
				rightList={selectedSKUs}
				leftState={"skus"}
				rightState={"selectedSKUs"}
			/>
			<CreateBasicModal />
		</Box>
		</CollapseSection>
		</Box>
	);
}
